import React from "react";
import Button, { ButtonType } from "../Assets/Button";
import { Check, X } from "lucide-react";
import { IUserRef } from "../../models/userData.model";
import { ITaskManagement } from "../../models/taskManagement.model";

interface TaskManagerApprovalTableProps {
  tasks: ITaskManagement[];
  onTaskClick: (task: ITaskManagement) => void;
  onUpdateStatus: (
    task: ITaskManagement,
    decision: "approved" | "rejected"
  ) => void;
  className?: string;
}

const TaskManagerApprovalTable: React.FC<TaskManagerApprovalTableProps> = ({
  tasks,
  onTaskClick,
  onUpdateStatus,
  className = "",
}) => {
  const waiting = tasks?.filter(
    (task) => task.status.toLowerCase() === "waiting for approval"
  );

  if (waiting?.length === 0) return null;

  return (
    <div className={`mb-2 mt-6 ${className}`}>
      <div className="overflow-x-auto border border-gray-200 rounded-lg">
        <table className="min-w-full divide-y divide-gray-200">
          <tbody className="bg-white divide-y divide-gray-200 text-xs">
            {waiting.map((task) => (
              <tr key={task._id} className="hover:bg-gray-50 transition-colors">
                <td className="px-6 py-2.5 whitespace-nowrap font-medium text-gray-900">
                  <span
                    onClick={() => onTaskClick(task)}
                    className="cursor-pointer hover:text-blue-600 transition-colors"
                  >
                    {task.taskName.capitalizeWords()}
                    {task.duplicate?.isDuplicate && (
                      <span className="ml-2 text-sm text-gray-500 italic">
                        (Duplicate Request)
                      </span>
                    )}
                  </span>
                </td>

                <td className="px-6 py-2.5 whitespace-nowrap text-gray-500">
                  {(
                    task.assignee as unknown as IUserRef
                  )?.username?.capitalizeWords()}
                </td>

                <td className="px-6 py-2.5 whitespace-nowrap">
                  <span className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full">
                    {task.status.capitalizeWords()}
                  </span>
                </td>

                <td className="px-6 py-2.5 whitespace-nowrap text-right">
                  <div className="flex gap-2 justify-end">
                    <Button
                      type={ButtonType.Extra}
                      onClick={() => onUpdateStatus(task, "approved")}
                      aria-label="Approve"
                      className="flex items-center gap-1"
                    >
                      <Check className="w-4 h-4 text-white" />
                      <span>Approve</span>
                    </Button>

                    <Button
                      type={ButtonType.Error}
                      onClick={() => onUpdateStatus(task, "rejected")}
                      aria-label="Reject"
                      className="flex items-center gap-1"
                    >
                      <X className="w-4 h-4" />
                      <span>Reject</span>
                    </Button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TaskManagerApprovalTable;
